import React from "react";
import useStyles from "./EmptyState.styles";

function SleepingFace(props) {
  return (
    <svg
      viewBox="0 0 48 48.0149"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 0C10.7443 0 0 9.2542 0 24.0074C0 38.7607 10.7443 48.0149 24 48.0149C37.2557 48.0149 48 38.7607 48 24.0074C48 9.2542 37.2557 0 24 0Z"
        fill="#1A1A1A"
        fillOpacity="0.3"
      />
      <path
        d="M24 27.2672C22.0186 27.2672 20.1461 26.9799 18.4966 26.4646C17.8526 26.2665 17.3077 26.9601 17.6495 27.5347C18.9375 29.6947 21.3003 31.1413 24 31.1413C26.6997 31.1413 29.0576 29.6947 30.3505 27.5347C30.6972 26.9601 30.1474 26.2665 29.5034 26.4646C27.8489 26.9749 25.9814 27.2672 24 27.2672Z"
        fill="#1A1A1A"
        fillOpacity="0.56"
      />
      <path
        d="M32.9115 19.96C31.4601 19.96 30.0632 19.311 28.7752 18.5778C27.8539 18.0576 26.9177 19.2515 27.6607 20.0046C28.9982 21.357 30.8557 22.1943 32.9115 22.1943C34.9672 22.1943 36.8248 21.357 38.1622 20.0046C38.9053 19.2515 37.9691 18.0527 37.0477 18.5778C35.7548 19.311 34.3628 19.96 32.9115 19.96Z"
        fill="#1A1A1A"
        fillOpacity="0.56"
      />
      <path
        d="M15.0935 19.96C13.6422 19.96 12.2452 19.311 10.9573 18.5778C10.0359 18.0576 9.09972 19.2515 9.84275 20.0046C11.1802 21.357 13.0378 22.1943 15.0935 22.1943C17.1493 22.1943 19.0068 21.357 20.3443 20.0046C21.0873 19.2515 20.1511 18.0527 19.2298 18.5778C17.9369 19.311 16.5449 19.96 15.0935 19.96Z"
        fill="#1A1A1A"
        fillOpacity="0.56"
      />
    </svg>
  );
}

function WorriedFace(props) {
  return (
    <svg
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 0C10.7443 0 0 9.25421 0 24.0074C0 38.7607 10.7443 48.0149 24 48.0149C37.2557 48.0149 48 38.7607 48 24.0074C48 9.25421 37.2557 0 24 0Z"
        fill="#1A1A1A"
        fillOpacity="0.3"
      />
      <path
        d="M18.9674 20.8711C17.1147 21.1138 15.807 22.7834 16.1141 25.1365C16.4212 27.4897 18.1153 28.7679 19.963 28.5251C21.8157 28.2824 23.1234 26.6129 22.8163 24.2597C22.5092 21.9065 20.815 20.6283 18.9674 20.8711Z"
        fill="#1A1A1A"
        fillOpacity="0.56"
      />
      <path
        d="M37.4937 19.4996C39.3464 19.7423 40.6194 21.6744 40.2578 24.4487C39.8962 27.223 38.1674 28.7637 36.3197 28.5259C34.4671 28.2832 33.194 26.3511 33.5556 23.5768C33.9173 20.8025 35.646 19.2618 37.4937 19.4996Z"
        fill="#1A1A1A"
        fillOpacity="0.56"
      />
      <path
        d="M35.2743 34.6535H16.4755C15.5739 34.6535 14.8408 33.9203 14.8408 33.0186C14.8408 32.117 15.5739 31.3838 16.4755 31.3838H35.2743C36.1758 31.3838 36.9089 32.117 36.9089 33.0186C36.9089 33.9203 36.1758 34.6535 35.2743 34.6535Z"
        fill="#1A1A1A"
        fillOpacity="0.56"
      />
      <path
        d="M34.9525 10.6708C36.3891 10.4429 37.8652 10.8689 39.2572 11.3891C40.2479 11.7607 40.986 10.428 40.134 9.8038C38.5984 8.67923 36.6318 8.13924 34.6058 8.46126C32.5748 8.78327 30.8758 9.90289 29.7612 11.4486C29.142 12.3106 30.2566 13.346 31.0838 12.6871C32.2429 11.7607 33.516 10.9036 34.9525 10.6757"
        fill="#1A1A1A"
        fillOpacity="0.56"
      />
      <path
        d="M18.4967 17.3141C17.0948 16.9376 15.579 17.2101 14.1425 17.5816C13.1171 17.8491 12.5227 16.4471 13.4342 15.9121C15.0787 14.951 17.0899 14.6191 19.0713 15.1492C21.0577 15.6793 22.6329 16.9673 23.579 18.622C24.1041 19.5434 22.8905 20.455 22.1326 19.7168C21.0725 18.6765 19.8936 17.6906 18.4917 17.3141"
        fill="#1A1A1A"
        fillOpacity="0.56"
      />
    </svg>
  );
}

const VARIANTS = {
  "no-orders": { message: "Nenhum pedido", Icon: SleepingFace },
  "no-results": {
    message: "Nenhum resultado para o filtro aplicado",
    Icon: WorriedFace,
  },
};

export default function EmptyState({ variant = "no-orders" }) {
  const classes = useStyles();
  const { message, Icon } = VARIANTS[variant] || VARIANTS["no-orders"];

  return (
    <div className={classes.root}>
      <Icon className={classes.icon} />
      <span className={classes.text}>{message}</span>
    </div>
  );
}
